import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppComponentStoreService {
    isOnTablet = new BehaviorSubject<boolean>(false);
    isOnTablet$ = this.isOnTablet.asObservable();
    setIsOnTablet(isOnTablet: boolean) {
        this.isOnTablet.next(isOnTablet);
    }

    getIsOnTablet(): Observable<boolean> {
        return this.isOnTablet$;
    }
}
